// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LinkPreview__container-c6d3c7 {
  margin-top: 4px;
  border-left: 2px solid var(--chat-bubble-primary);
  background-color: inherit;
  padding-inline-start: 8px;
  width: 100vw;
  max-width: 100%;
  box-sizing: border-box;
}

.LinkPreview__domain-e90c11 {
  color: var(--chat-bubble-text-secondary);
  font: var(--font-button);
  letter-spacing: var(--font-button);
}

.LinkPreview__title-a6e9c6 {
  color: var(--chat-bubble-text-primary);
  font: var(--font-body-6);
  letter-spacing: var(--font-spacing-body-6);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.LinkPreview__description-e8e340 {
  color: var(--chat-bubble-text-secondary);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-subtitle-4);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.LinkPreview__image-container-a0ad9a {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-top: 4px;
  border-radius: 8px;
  overflow: hidden;
  max-width: 100%;
  background-size: cover;
  cursor: pointer;
  background-color: inherit;
}

.LinkPreview__image-d31ab5 {
  background-color: var(--base-20);
  max-height: 100%;
  max-width: 100%;
  background-color: inherit;
}

.LinkPreview__youtube-ec6a64 {
  margin-top: 4px;
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/Payload/Text/LinkPreview/LinkPreview.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,iDAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;AACF;;AAEA;EACE,wCAAA;EACA,wBAAA;EACA,kCAAA;AACF;;AAEA;EACE,sCAAA;EACA,wBAAA;EACA,0CAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AACF;;AAEA;EACE,wCAAA;EACA,4BAAA;EACA,sCAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;AACF;;AAEA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AACF;;AAEA;EACE,eAAA;EACA,kBAAA;AACF","sourcesContent":[".container {\n  margin-top: 4px;\n  border-left: 2px solid var(--chat-bubble-primary);\n  background-color: inherit;\n  padding-inline-start: 8px;\n  width: 100vw;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.domain {\n  color: var(--chat-bubble-text-secondary);\n  font: var(--font-button);\n  letter-spacing: var(--font-button);\n}\n\n.title {\n  color: var(--chat-bubble-text-primary);\n  font: var(--font-body-6);\n  letter-spacing: var(--font-spacing-body-6);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n}\n\n.description {\n  color: var(--chat-bubble-text-secondary);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-subtitle-4);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.image-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  margin-top: 4px;\n  border-radius: 8px;\n  overflow: hidden;\n  max-width: 100%;\n  background-size: cover;\n  cursor: pointer;\n  background-color: inherit;\n}\n\n.image {\n  background-color: var(--base-20);\n  max-height: 100%;\n  max-width: 100%;\n  background-color: inherit;\n}\n\n.youtube {\n  margin-top: 4px;\n  border-radius: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LinkPreview__container-c6d3c7`,
	"domain": `LinkPreview__domain-e90c11`,
	"title": `LinkPreview__title-a6e9c6`,
	"description": `LinkPreview__description-e8e340`,
	"image-container": `LinkPreview__image-container-a0ad9a`,
	"imageContainer": `LinkPreview__image-container-a0ad9a`,
	"image": `LinkPreview__image-d31ab5`,
	"youtube": `LinkPreview__youtube-ec6a64`
};
module.exports = ___CSS_LOADER_EXPORT___;
